module.exports = __webpack_public_path__ + "static/img/Multiple-signs.a7729aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/Multiple-signs.jpg
// module id = 6kRs
// module chunks = 1